module.exports = __webpack_public_path__ + "media/fonts/suisse-works/SuisseWorks-RegularItalic-184a506841124a57ba3bd9b06bec29fd.ttf";